module.exports = __webpack_public_path__ + "static/media/downloadLogo.0288ddc2.svg";